module.exports = __webpack_public_path__ + "files/6bb1a620354df5da5188bafb793dcb4a.png";